import Rest from '../Rest';
import browser from '@/util/BrowserUtils'

export interface FileItem {
  vuuid: string | number;
  name: string;
  path: string;
  type: 'file' | 'directory' | 'drive';
  url_tmp?: string;
  mime_type?: string;
  size?: number;
  modified?: string;
  extension?: string;
  folder_count?: number;
  file_count?: number;
  total_children?: number;
  has_children?: boolean;
  children?: FileItem[];
  parent_id?: number;
  resource_id?: number;
  media_id?: number;
  is_owner?: boolean;
  owner_name?: string;
}

export interface ListFilesResponse {
  items: FileItem[];
  path: string;
  total: number;
}


// Em ambiente de desenvolvimento, use itens de exemplo
const dataMockDrives =  [
    { vuuid: 1000, type: 'drive', name: 'Meu Drive', path: 'Meu Drive/', created: '2023-08-10T14:30:00Z',
      children: [
        { vuuid: 1001, type: 'directory', name: 'Folder 1', path: 'Meu Drive/Folder 1', created: '2023-08-10T14:30:00Z'},
        { vuuid: 1002, type: 'directory', name: 'Folder 2', path: 'Meu Drive/Folder 2', created: '2023-08-10T14:30:00Z',
          children: [
            { vuuid: 1003, type: 'directory', name: 'Folder 3', path: 'Meu Drive/Folder 2/Folder 3', created: '2023-08-10T14:30:00Z'},
            { vuuid: 1004, type: 'directory', name: 'Folder 4', path: 'Meu Drive/Folder 2/Folder 4', created: '2023-08-10T14:30:00Z',
              children: [
                { vuuid: 1005, type: 'directory', name: 'Folder 5', path: 'Meu Drive/Folder 2/Folder 4/Folder 5', created: '2023-08-10T14:30:00Z'},
                { vuuid: 1006, type: 'directory', name: 'Folder 6', path: 'Meu Drive/Folder 2/Folder 4/Folder 6', created: '2023-08-10T14:30:00Z'},
              ]
            },
          ]
        },
      ]
    },
    { vuuid: 100, type: 'drive', name: 'Meu Drive 2', path: 'Meu Drive 2/', created: '2023-08-10T14:30:00Z',
      children: [
        { vuuid: 101, type: 'directory', name: 'Folder 3', path: '/Folder 3', created: '2023-08-10T14:30:00Z'},
        { vuuid: 102, type: 'directory', name: 'Folder 4', path: '/Folder 4', created: '2023-08-10T14:30:00Z'},
      ]
    }
]
const dataMock =  [
    { vuuid: 1, type: 'directory', name: 'Documents', path: 'Documents', created: '2023-08-10T14:30:00Z'},
    { vuuid: 2, type: 'directory', name: 'Images', path: 'Images', created: '2023-08-15T09:45:00Z'},
    { vuuid: 3, type: 'file', name: 'config.json', path: 'config.json', size: 2048, modified: '2023-08-20T11:22:00Z', mime_type: 'application/json' },
    { vuuid: 4, type: 'file', name: 'readme texto longo abaldadfdaf f fdaf sd.txt', path: 'readme.txt', size: 1024, modified: '2023-08-18T16:00:00Z', mime_type: 'text/plain' },
    { vuuid: 5, type: 'file', name: 'image.jpg', path: 'image.jpg', size: 5242880, modified: '2023-08-22T10:15:00Z', mime_type: 'image/jpeg' },
    { vuuid: 6, type: 'file', name: 'video.mp4', path: 'video.mp4', size: 15728640, modified: '2023-08-05T13:45:00Z', mime_type: 'video/mp4' },
    { vuuid: 7, type: 'file', name: 'document1.pdf', path: 'document1.pdf', size: 3145728, modified: '2023-08-25T14:22:00Z', mime_type: 'application/pdf' },
    { vuuid: 8, type: 'file', name: 'document.pdf', path: 'document.pdf', size: 3145728, modified: '2023-08-24T14:22:00Z', mime_type: 'application/pdf' },
    { vuuid: 9, type: 'file', name: 'archive.zip', path: 'archive.zip', size: 10485760, modified: '2023-08-12T08:30:00Z', mime_type: 'application/zip' },
    { vuuid: 10, type: 'file', name: 'relatorio.docx', path: 'relatorio.docx', size: 2359296, modified: '2023-09-05T09:15:00Z', mime_type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
    { vuuid: 11, type: 'file', name: 'planilha.xlsx', path: 'planilha.xlsx', size: 1572864, modified: '2023-09-02T13:40:00Z', mime_type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
    { vuuid: 12, type: 'file', name: 'dados.csv', path: 'dados.csv', size: 512000, modified: '2023-09-01T10:20:00Z', mime_type: 'text/csv' }
  ]

export default class FileExplorerService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/drive';

  static build(vs: any = null) {
    return new this(this.resource, null, vs);
  }

  /**
   * Listar arquivos e pastas em um diretório
   * @param path Caminho do diretório (vazio para raiz)
   * @param resource_id ID do recurso (opcional, mas recomendado para performance)
   */
  async listItems(path: string = '', resource_id?: number, isShared: boolean = false): Promise<ListFilesResponse> {
    try {
      const response = await this.get('', {
        params: {
          path,
          resource_id: resource_id ?? '',
          is_shared: isShared
        }
      });

      return {
        items: response.items.map((item: any) => {
          const extension = item.extension || (item.type === 'file' ? this.getFileExtension(item.name) : undefined);
          return {
            vuuid: item.vuuid,
            name: item.name,
            path: item.path,
            type: item.type,
            size: item.size,
            url_tmp: item.url_tmp,
            modified: item.modified,
            extension,
            mime_type: item.mime_type,
            folder_count: item.folder_count,
            file_count: item.file_count,
            total_children: item.total_children,
            has_children: item.folder_count > 0 || (item.children && item.children.length > 0),
            resource_id: item.resource_id,
            parent_id: item.parent_id,
            media_id: item.media_id,
            is_owner: item.is_owner,
            owner_name: item.owner_name
          };
        }),
        path: response.path,
        total: response.total
      };
    } catch (error) {
      console.error('Error listing files:', error);
      throw error;
    }
  }

  /**
   * Criar um novo diretório
   * @param path Caminho onde o diretório será criado
   * @param name Nome do novo diretório
   * @param parent_id ID do recurso pai (obrigatório)
   */
  async createDirectory(path: string, name: string, parent_id?: number): Promise<void> {
    try {
      await this.post('directory', {
        params: {
          path,
          name,
          parent_id
        }
      });
    } catch (error) {
      console.error('Error creating directory:', error);
      throw error;
    }
  }

  /**
   * Renomear um arquivo ou diretório
   * @param path Caminho completo do arquivo ou diretório
   * @param name Novo nome
   * @param resource_id ID do recurso (opcional, mas recomendado para performance)
   * @param type Tipo do item ('file' ou 'directory')
   * @param media_id ID da mídia (somente para arquivos)
   * @returns Objeto com informações sobre o item renomeado
   */
  async rename(path: string, name: string, resource_id?: number, type: string = 'directory', media_id?: number): Promise<any> {
    try {
      // Preparar dados para a requisição
      const data: any = {
        path,
        name, // Usando 'name' como parâmetro correto
        type
      };

      // Se tivermos o resource_id, incluí-lo
      if (resource_id) {
        data.resource_id = resource_id;
      }

      // Se for um arquivo e tivermos o media_id, incluí-lo
      if (type === 'file' && media_id) {
        data.media_id = media_id;
      }

      // Fazer a requisição
      const response = await this.put('rename', data);

      console.log('Resposta da API para rename:', response);

      // Retornar a resposta completa para permitir mais flexibilidade
      return response;
    } catch (error) {
      console.error('Error renaming file/directory:', error);
      throw error;
    }
  }

  /**
   * Excluir um arquivo ou diretório
   * @param path Caminho completo do arquivo ou diretório (usado para referência)
   * @param resource_id ID do recurso (pasta) a que o item pertence
   * @param media_id ID da mídia (somente para arquivos)
   * @param type Tipo do item ('file' ou 'directory')
   */
  async deleteItem(path: string, resource_id: number, type: string = 'directory', media_id?: number): Promise<void> {
    try {
      // Usando o verbo HTTP DELETE
      const params: any = {
        params: {
          path,
          resource_id
        }
      };

      // Se for um arquivo, inclui o media_id nos parâmetros
      if (type === 'file' && media_id) {
        params.params.media_id = media_id;
        params.params.type = 'file';
      } else {
        params.params.type = type;
      }

      await this.delete('', params);
    } catch (error) {
      console.error('Error deleting file/directory:', error);
      throw error;
    }
  }

  /**
   * Fazer upload de um arquivo
   * @param path Caminho do diretório de destino
   * @param files Arquivo(s) a ser(em) enviado(s)
   * @param resource_id ID do recurso (pasta) de destino
   */
  async uploadFile(path: string, files: File | File[], resource_id?: number): Promise<void> {
    try {
      const formData = new FormData();

      // Suporte para múltiplos arquivos
      if (Array.isArray(files)) {
        files.forEach((file, index) => {
          formData.append(`files[${index}]`, file);
        });
      } else {
        formData.append('files[0]', files);
      }

      // Enviando os parâmetros em um objeto params
      formData.append('params[path]', path);
      if (resource_id) {
        formData.append('params[resource_id]', resource_id.toString());
      }

      await this.post('upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    } catch (error) {
      console.error('Error uploading file(s):', error);
      throw error;
    }
  }

  /**
   * Obter URL para download de um diretório como ZIP
   */
  getDirectoryDownloadUrl(resourceId: number, type: string = 'directory'): string {
    const baseUrl = process.env.VUE_APP_API_BASE_URL
    const resource = FileExplorerService.resource
    return Rest.normalize(`${baseUrl}${resource}/download?resource_id=${resourceId}&type=${type}`);
  }

  /**
   * Fazer download de um diretório como arquivo ZIP
   * @param resourceId ID do recurso (pasta) para download
   * @param resourceName Nome do recurso (pasta) para download
   * @param type Tipo do recurso ('directory' ou 'drive')
   */
  async downloadDirectoryAsZip(resourceId: number, resourceName: string, type: string = 'directory'): Promise<void> {
    try {

      const url = this.getDirectoryDownloadUrl(resourceId, type);
      console.log('URL para download:', url);

      const openTab = () => browser.newTab(url)
      openTab()

      console.log('Resposta da API para downloadDirectoryAsZip:');

    } catch (error) {
      console.error('Error downloading directory:', error);
      throw error;
    }
  }

  /**
   * Extrair extensão de um arquivo
   * @param filename Nome do arquivo
   */
  private getFileExtension(filename: string): string {
    return filename?.split('.').pop()?.toLowerCase() || '';
  }

  /**
   * Obter a estrutura completa em formato de árvore
   * @param rootPath Caminho inicial para construir a árvore
   * @param resource_id ID do recurso (opcional, mas recomendado para performance)
   */
  async getTreeStructure(rootPath: string = '', resource_id?: number): Promise<FileItem[]> {
    try {
      const response = await this.get('/', {
        params: {
          path: rootPath,
          resource_id
        }
      });

      // Mapear a resposta para o formato de itens de arquivo
      return this.mapTreeItems(response.items || []);
      //return this.mapTreeItems(dataMockDrives);

    } catch (error) {
      console.error('Error getting tree structure:', error);
      throw error;
    }
  }

  /**
   * Mapear os itens da árvore para o formato padrão
   * @param items Itens da árvore
   */
  private mapTreeItems(items: any[]): FileItem[] {
    return items.map(item => {
      const extension = item.extension || (item.type === 'file' ? this.getFileExtension(item.name) : undefined);
      return {
        vuuid: item.vuuid,
        name: item.name,
        path: item.path,
        type: item.type,
        size: item.size,
        url_tmp: item.url_tmp,
        modified: item.modified,
        extension,
        mime_type: item.mime_type,
        folder_count: item.folder_count,
        file_count: item.file_count,
        total_children: item.total_children,
        has_children: item.folder_count > 0 || (item.children && item.children.length > 0),
        resource_id: item.resource_id,
        parent_id: item.parent_id,
        media_id: item.media_id,
        children: item.children ? this.mapTreeItems(item.children) : undefined
      };
    });
  }

  /**
   * Obter os filhos diretos (apenas um nível) para um diretório ou drive específico
   * @param path Caminho completo do diretório ou drive
   * @param resource_id ID do recurso (opcional, mas recomendado para performance)
   * @param isShared Indica se é um recurso compartilhado
   */
  async getDirectoryChildren(path: string, resource_id?: number, isShared: boolean = false): Promise<FileItem[]> {
    try {
      // Em um ambiente real, chamaríamos a API
      const response = await this.get('/', {
        params: {
          path,
          resource_id: resource_id ?? '',
          only_dir: true,
          is_shared: isShared
        }
      });

      console.log('Resposta da API para getDirectoryChildren:', {
        path: path,
        resource_id: resource_id ?? '',
        only_dir: true,
        isShared: isShared,
        items: response.items
      });

      // Mapear os itens garantindo que o parent_id está incluído
      const mappedItems = response.items.map((item: any) => {
        const extension = item.extension || (item.type === 'file' ? this.getFileExtension(item.name) : undefined);
        return {
          vuuid: item.vuuid,
          name: item.name,
          path: item.path,
          type: item.type,
          size: item.size,
          url_tmp: item.url_tmp,
          modified: item.modified,
          extension,
          mime_type: item.mime_type,
          folder_count: item.folder_count,
          file_count: item.file_count,
          total_children: item.total_children,
          has_children: item.folder_count > 0 || (item.children && item.children.length > 0),
          resource_id: item.resource_id,
          parent_id: item.parent_id, // Garantir que o parent_id é mapeado
          media_id: item.media_id
        };
      });

      console.log('Items mapeados com parent_id:', mappedItems);
      return mappedItems;

      // let result = this.getDataMock(path);
      // return result;
    } catch (error) {
      console.error('Error getting directory children:', error);
      throw error;
    }
  }

  private getDataMock(path: string){
    // Simulação com dados de teste
      // Encontrar o nó correspondente em nossos dados de exemplo
      let result: FileItem[] = [];

      if (!path || path === '') {
        // Se o caminho for vazio, retornar os drives (nível raiz)
        return dataMockDrives.map(drive => {
          // Para os drives no nível raiz, incluímos um indicador de que têm filhos,
          // mas não enviamos os filhos reais (eles serão carregados sob demanda)
          return {
            vuuid: drive.vuuid,
            name: drive.name,
            path: drive.path,
            type: drive.type as 'drive', // Garantir o tipo correto
            has_children: drive.children && drive.children.length > 0,
            // Não incluir children aqui, para forçar o carregamento sob demanda
          };
        });
      }

      // Função recursiva para encontrar a pasta correspondente
      const findNode = (nodes: any[], searchPath: string): any[] | null => {
        for (const node of nodes) {
          if (node.path === searchPath) {
            return node.children || [];
          }
          if (node.children) {
            const found = findNode(node.children, searchPath);
            if (found) return found;
          }
        }
        return null;
      };

      // Procurar nos dados mock
      const foundChildren = findNode(dataMockDrives, path);

      if (foundChildren) {
        result = foundChildren.map((child: any) => {
          // Garantir que o tipo seja um dos valores permitidos
          const itemType = child.type === 'directory' ? 'directory' :
                           child.type === 'drive' ? 'drive' : 'file';

          return {
            vuuid: child.vuuid,
            name: child.name,
            path: child.path,
            type: itemType as 'file' | 'directory' | 'drive',
            has_children: child.children && child.children.length > 0,
            // Não incluir children aqui, para forçar o carregamento sob demanda
          };
        });
      }
  }

  /**
   * Compartilhar recurso com usuário ou grupo
   * @param params Parâmetros para compartilhamento ({resource_id, resource_type, user_id/group_id, share_type})
   * @returns Promise com a resposta
   */
  async shareResource(params: any): Promise<any> {
    try {
      const response = await this.post('sharing', {params: params});
      return response;
    } catch (error) {
      console.error('Error sharing resource:', error);
      throw error;
    }
  }

  /**
   * Remover compartilhamento de recurso
   * @param params Parâmetros para remoção ({resource_id, resource_type, user_id/group_id, share_type})
   * @returns Promise com a resposta
   */
  async removeResourceSharing(params: any): Promise<any> {
    try {
      // Usando o verbo HTTP DELETE com corpo de requisição
      const response = await this.delete('sharing', {params: params});
      return response;
    } catch (error) {
      console.error('Error removing resource sharing:', error);
      throw error;
    }
  }

  /**
   * Obter compartilhamentos existentes de um recurso
   * @param params Parâmetros para consulta ({resource_id, resource_type})
   * @returns Promise com a resposta contendo usuários e grupos
   */
  async getResourceSharing(params: any): Promise<any> {
    try {
      const response = await this.get('sharing', {params: params});
      return response;
    } catch (error) {
      console.error('Error getting resource sharing:', error);
      throw error;
    }
  }

  /**
   * Obter recurso compartilhado por link público
   * @param type Tipo do recurso ('file' ou 'directory')
   * @param link Link público
   * @param params Parâmetros para consulta ({path, resource_id})
   * @returns Promise com a resposta
   */
  async getResourceByPublicLink(type: string, link: string, params: any): Promise<FileItem[]> {
    try {
      const response = await this.get(`pub/sharing/${type}/${link}`, {params: params});
      return response
    } catch (error) {
      console.error('Error getting resource by public link:', error);
      throw error;
    }
  }

  /**
   * Obtém todos os usuário/grupo com quem um recurso está compartilhado
   * @param params Parâmetros para consulta ({resource_id, media_id, type})
   * @returns Promise com a resposta contendo usuários e grupos
   */
  async getSharedResourcesFor(params: any): Promise<any> {
    try {
      const response = await this.get('shared_for', {params: params});
      return response;
    } catch (error) {
      console.error('Error getting shared resources for:', error);
      throw error;
    }
  }

  /**
   * Obtém a URL para visualização do arquivo
   * @param file O arquivo para obter a URL de visualização
   * @returns Promise com a URL do arquivo ou null se não suportado
   */
  async getPreviewUrl(file: any): Promise<string | null> {
    // Lista de tipos MIME suportados para preview
    const supportedMimeTypes = [
      // Imagens
      'image/jpeg',
      'image/png',
      'image/gif',
      'image/webp',
      'image/svg+xml',
      // PDF
      'application/pdf',
      // Texto
      'text/plain',
      'text/html',
      'text/css',
      'text/javascript',
      'application/json',
      'application/xml',
      // Vídeo
      'video/mp4',
      'video/webm',
      'video/ogg',
      // Áudio
      'audio/mpeg',
      'audio/ogg',
      'audio/wav'
    ];

    // Verificar se o tipo do arquivo é suportado
    if (!supportedMimeTypes.includes(file.mime_type)) {
      return null;
    }

    // Função para limpar a URL de parâmetros de download
    const cleanUrl = (url: string): string => {
      try {
        const urlObj = new URL(url);
        // Remover o parâmetro response-content-disposition
        urlObj.searchParams.delete('response-content-disposition');
        // Remover outros parâmetros relacionados ao download se existirem
        urlObj.searchParams.delete('response-content-type');
        urlObj.searchParams.delete('response-content-language');
        urlObj.searchParams.delete('response-expires');
        urlObj.searchParams.delete('response-cache-control');
        return urlObj.toString();
      } catch (error) {
        console.warn('Erro ao limpar URL:', error);
        return url;
      }
    };

    // Se tiver url_tmp, usar ela após limpar os parâmetros de download
    if (file.url_tmp) {
      return cleanUrl(file.url_tmp);
    }

    // Se não tiver url_tmp, buscar a URL do arquivo no servidor
    try {
      const response = await this.get(`/preview/${file.resource_id}`);
      return response.data.preview_url;
    } catch (error) {
      console.error('Erro ao obter URL do arquivo:', error);
      return null;
    }
  }
}
